// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3jbeJ","requiredAsterisk":"Info_requiredAsterisk__3Cc2V"};